export const BUNNY_STORAGE = 'bunnyNotes'
